import type { CityConfig } from "../city-template/types";

export const parkerConfig: CityConfig = {
  city: "Parker",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "parker",
  route: "/parker",
  title: "Emergency Passport Parker, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Parker, Colorado — as fast as 24 hours. Same-day courier processing for Parker, Castle Rock, Lone Tree, Centennial, and all Douglas County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Parker, CO",
  heroSubtitle: "Family vacation to Disneyland Paris and your kids need passports? Business trip to London next week? We help Parker residents — from Pinery families to Canterberry homeowners to Stroh Ranch professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Parker%20Colorado%20suburban%20landscape%20with%20wide%20open%20prairie%20grasslands%20and%20distant%20Rocky%20Mountain%20front%20range%20peaks%2C%20modern%20residential%20development%20with%20family%20homes%20and%20greenbelts%2C%20the%20iconic%20Parker%20water%20tower%20landmark%20surrounded%20by%20open%20space%20trails%2C%20sunny%20Colorado%20day%20with%20bright%20blue%20sky%20and%20scattered%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20natural%20lighting%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20composition%20emphasizing%20the%20open%20space%20character&width=1800&height=700&seq=parker-hero-001&orientation=landscape",
  heroImageAlt: "Parker Colorado suburban landscape with Rocky Mountain Front Range backdrop",
  geoPosition: "39.5186;-104.7614",
  geoPlacename: "Parker, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 25 miles north via Parker Road and I-25 — about 35 minutes",
  },
  nearbyCitiesZips: [
    { name: "Parker", zips: "80134, 80138" },
    { name: "Castle Rock", zips: "80104, 80108, 80109" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Centennial", zips: "80111, 80112" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Elizabeth", zips: "80107" },
    { name: "Franktown", zips: "80116" },
    { name: "Sedalia", zips: "80135" },
    { name: "Larkspur", zips: "80118" },
    { name: "The Pinery", zips: "80134" },
    { name: "Aurora", zips: "80015, 80016" },
    { name: "Greenwood Village", zips: "80111" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Parker international travel — family vacations and business" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive to Aurora for the Colorado Passport Agency" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Access", desc: "35 minutes from DEN — same-day courier coordination for last-minute international flights" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Parker, Lone Tree, or Castle Rock" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Castle Rock, CO", route: "/castle-rock" },
    { name: "Fast passport renewal in Douglas County", route: "/parker" },
    { name: "Urgent passport services for Lone Tree", route: "/parker" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in south metro", route: "/parker" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Parker remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Parker's location in Douglas County gives us a strong presence in one of Colorado's fastest-growing regions — but you never need to make the drive to Aurora yourself.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Douglas County including Parker, Castle Rock, Lone Tree, and the surrounding communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Parker and Douglas County. From the Pinery to Canterberry, from Stroh Ranch to Bradbury Ranch — we serve every neighborhood in Parker and the surrounding south metro communities.",
  nearbyCitiesIntro: "We serve Parker and all nearby Douglas County communities including Castle Rock, Lone Tree, Centennial, Highlands Ranch, Elizabeth, Franktown, and Sedalia. We also serve the southern Aurora area.",
  howItWorksIntro: "Most Parker travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 25 miles north on Parker Road to the Colorado Passport Agency.",
  mistakesIntro: "Parker is one of Colorado's fastest-growing communities with families who travel internationally for vacations, sports tournaments, and school trips. Here are the most common passport mistakes we see from Parker-area travelers.",
  testimonialsIntro: "Parker travelers — from Pinery families to Stroh Ranch professionals to Canterberry residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Parker, CO? Here are the most common ones we hear from Douglas County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (35 minutes each way)", "Limited appointments — book 3 weeks ahead"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Parker", "Perfect for family vacations and sports travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Parker travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the drive to Aurora.",
      bullets: ["24–48 hour turnaround available", "DEN departure support", "Family and sports travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Parker adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Parker address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Parker residents — including young adults and recent arrivals to Douglas County.",
      bullets: ["Acceptance facility scheduling in Parker or Castle Rock", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Parker residents who lost their passport before international travel — family vacation or business.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Parker and Douglas County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Parker and Douglas County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Parker CO", description: "Urgent passport processing for Parker Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Parker CO", description: "Fast passport renewal for Parker Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Parker CO", description: "New passport application services for Parker Colorado residents applying for their first passport." },
    { name: "Child Passport Parker CO", description: "Minor passport services for Parker Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Chris D.",
      location: "Parker, CO — The Pinery",
      rating: 5,
      text: "Family trip to Costa Rica over winter break. Two adult renewals and two first-time passports for our kids. All done in 5 days. The courier service is a lifesaver for busy families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Melissa K.",
      location: "Parker, CO — Canterberry",
      rating: 5,
      text: "My son's hockey team tournament in Toronto — realized his passport had expired 3 weeks before. Fast Passport Center got it in 3 days. He didn't miss a single practice.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Brian W.",
      location: "Castle Rock, CO",
      rating: 5,
      text: "Business trip to Dubai with 7 days notice and my passport was expiring. They handled everything in 2 days. Absolutely flawless process from start to finish.",
      service: "Emergency Passport",
    },
    {
      name: "Stephanie R.",
      location: "Lone Tree, CO",
      rating: 5,
      text: "Lost my passport during a home move from Parker to Lone Tree. Replacement in 48 hours with daily email updates. Incredible peace of mind during a stressful time.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "prk-1",
      name: "Parker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18695 Pony Express Dr",
      city: "Parker",
      state: "CO",
      zip: "80134",
      phone: "(303) 841-2675",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Parker, near Parker Road and E-470",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Parker acceptance facility. Appointments strongly recommended. Good parking. Popular location — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "prk-2",
      name: "Castle Rock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E Miller Ct",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 688-2329",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Castle Rock, approximately 12 miles south of Parker",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Castle Rock and south Parker residents. Good availability compared to Parker location.",
      icon: "ri-mail-line",
    },
    {
      id: "prk-3",
      name: "Lone Tree Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8080 S Broadway",
      city: "Lone Tree",
      state: "CO",
      zip: "80124",
      phone: "(303) 799-8255",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Lone Tree, approximately 8 miles northwest of Parker",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for west Parker and Lone Tree residents. Extended hours. Modern facility.",
      icon: "ri-mail-line",
    },
    {
      id: "prk-4",
      name: "Highlands Ranch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9609 S University Blvd",
      city: "Highlands Ranch",
      state: "CO",
      zip: "80126",
      phone: "(303) 471-3930",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Highlands Ranch, approximately 10 miles west of Parker",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for west Parker residents. Good availability and modern facility.",
      icon: "ri-mail-line",
    },
    {
      id: "prk-5",
      name: "Douglas County Clerk — Castle Rock",
      type: "County Clerk Passport Acceptance",
      address: "301 Wilcox St",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 660-7446",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Castle Rock, approximately 12 miles south of Parker",
      website: "https://www.douglas.co.us/",
      websiteLabel: "Douglas County Clerk",
      notes: "County clerk passport acceptance. Extended hours compared to post offices. Full-service county office. Good for all Douglas County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35-min drive to Aurora on Parker Rd/I-25", fpc: "No — ship from Parker" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Family Bundles", agency: "Separate appointments for each person", fpc: "Bundle entire family — one dedicated agent" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Not Checking Passports Before Booking Family Travel",
      description: "Parker families often book international vacations months in advance but overlook passport expiration dates. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your trip.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Both Parents for Child Passports",
      description: "Both parents must appear in person for any child's passport (under 16). Many Parker families show up with only one parent and are turned away — this is one of the most common and preventable mistakes.",
    },
    {
      icon: "ri-image-line",
      title: "Using School Photos as Passport Photos",
      description: "School pictures and sports team photos are not valid passport photos. Passport photos must be exactly 2×2 inches on a white background, taken within 6 months — no exceptions.",
    },
    {
      icon: "ri-global-line",
      title: "Ignoring Visa Requirements",
      description: "Having a valid passport doesn't guarantee entry to every country. Many destinations popular with Parker travelers — like Brazil, China, and India — require visas. Check visa requirements before booking.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting for Peak Season",
      description: "Parker families travel most during school breaks — summer, winter break, and spring break. These coincide with peak passport demand nationwide. Submit your application well before the rush.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using the Wrong Application Form",
      description: "Not all passport applications use the same form. First-time applicants must use DS-11. Most renewals use DS-82. Using the wrong form means your application will be rejected.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Parker or Douglas County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Parker, Lone Tree, or Castle Rock." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Douglas County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no Parker Road traffic required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Parker address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Parker, CO?", a: "Fast Passport Center offers emergency passport processing in Parker, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 25-mile drive north to the Colorado Passport Agency in Aurora." },
    { q: "Does Parker have its own passport agency?", a: "No — Parker does not have a regional passport agency. The nearest is the Colorado Passport Agency (25 miles north via Parker Road and I-25). Fast Passport Center's courier service means Parker residents never need to deal with Parker Road and I-25 traffic." },
    { q: "Can you process passports for my whole family at once?", a: "Yes — that's one of our specialties. Fast Passport Center offers family passport bundles for Parker families. We can process adult renewals, first-time adult, and child passports in one batch with a single dedicated agent. Perfect for family vacations, sports tournaments, or school trips abroad." },
    { q: "What if I live in Castle Rock, Lone Tree, or The Pinery?", a: "Absolutely. Fast Passport Center serves all of Douglas County including Castle Rock, Lone Tree, Highlands Ranch, The Pinery, Elizabeth, Franktown, and Sedalia. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "How far is Parker from Denver International Airport (DEN)?", a: "Denver International Airport is approximately 35 minutes north of Parker via E-470. DEN offers extensive international flights to Europe, Asia, Mexico, and Canada. Parker's proximity to E-470 makes it one of the most convenient south metro communities for international travel." },
    { q: "How much does an expedited passport cost in Parker, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline and family size." },
    { q: "Where can I get passport photos in Parker?", a: "Walgreens (11105 S Parker Rd and 17001 Lincoln Ave) offers passport photo services. UPS Store at Parker and Lincoln, and CVS on Parker Road also provide photos. FedEx Office in Lone Tree is another option. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve E-470 corridor communities?", a: "Yes. Fast Passport Center serves the entire E-470 corridor from Parker to Lone Tree to Highlands Ranch to Centennial. Our registered courier network provides complete coverage of the south metro area, including all Douglas County and Arapahoe County communities." },
  ],
  photoLocations: [
    { name: "Walgreens — Parker Rd Parker", address: "11105 S Parker Rd, Parker, CO 80134", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lincoln Ave Parker", address: "17001 Lincoln Ave, Parker, CO 80134", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Parker", address: "11211 S Dransfeldt Rd, Parker, CO 80134", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "FedEx Office — Lone Tree", address: "8451 S Yosemite St, Lone Tree, CO 80124", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Castle Rock (Douglas County)", address: "301 Wilcox St, Castle Rock, CO 80104", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Parker and Douglas County residents. REAL ID and driver's license renewals. Approximately 12 miles south of Parker.", featured: true },
    { name: "DMV — Centennial (Arapahoe County)", address: "6954 S Lima St, Centennial, CO 80112", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for north Parker residents. REAL ID processing available. Approximately 12 miles from Parker.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "28 miles from Parker via E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. About 35 minutes from Parker via E-470 toll road.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "55 miles from Parker via I-25 south",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative regional airport with domestic connections. About 50 minutes south of Parker. Convenient for southern Douglas County residents.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "20 miles from Parker via E-470",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "One of the busiest general aviation airports in the U.S. Private jet and charter services available. No commercial passenger flights.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Airport Info",
      featured: false,
    },
  ],
};